import { render, staticRenderFns } from "./InboxConversationCard.vue?vue&type=template&id=d847b95a"
import script from "./InboxConversationCard.vue?vue&type=script&lang=ts"
export * from "./InboxConversationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports